import { render, staticRenderFns } from "./table2.vue?vue&type=template&id=5d60e3bc&scoped=true"
import script from "./table2.vue?vue&type=script&lang=js"
export * from "./table2.vue?vue&type=script&lang=js"
import style0 from "./table2.vue?vue&type=style&index=0&id=5d60e3bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60e3bc",
  null
  
)

export default component.exports